
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overseas",
      function () {
        return require("private-next-pages/overseas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/overseas"])
      });
    }
  